/**
 * Returns an array of all available IANA time zones with their GMT offsets in the format:
 * [
 *   { offset: "GMT-05:00", label: "America/New_York" },
 *   ...
 * ]
 */
export function getTimeZonesWithOffsets(date = new Date()) {
  // Intl.supportedValuesOf is available in modern browsers/node,
  // otherwise fallback to a minimal static list.
  let timeZoneNames;
  if (typeof Intl.supportedValuesOf === 'function') {
    timeZoneNames = Intl.supportedValuesOf('timeZone');
  } else {
    // Fallback if supportedValuesOf not available (list can be extended)
    timeZoneNames = [
      "UTC", "America/New_York", "America/Chicago", "America/Denver", "America/Los_Angeles", 
      "Europe/London", "Europe/Berlin", "Europe/Paris", "Asia/Kolkata", "Asia/Tokyo", 
      "Australia/Sydney"
    ];
  }

  function getOffsetString(tz, dateObj) {
    try {
      // Get the UTC time in milliseconds
      const utcDate = new Date(dateObj.toLocaleString('en-US', { timeZone: 'UTC' }));
      // Get the local time in the target timezone in milliseconds
      const tzDate = new Date(dateObj.toLocaleString('en-US', { timeZone: tz }));
      // Offset in minutes (local time minus UTC time)
      const offsetMinutes = Math.round((tzDate - utcDate) / (60 * 1000));
      const sign = offsetMinutes >= 0 ? '+' : '-';
      const absMinutes = Math.abs(offsetMinutes);
      const hours = Math.floor(absMinutes / 60);
      const minutes = absMinutes % 60;
      return `GMT${sign}${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
    } catch {
      return "GMT";
    }
  }

  return timeZoneNames
    .map(tz => {
      const offset = getOffsetString(tz, date);
      return {
        offset: offset,
        label: tz
      };
    })
    .sort((a, b) => {
      // Compare by offset, then by label name
      const parseOffset = (offsetStr) => {
        // offsetStr is e.g. "GMT-05:00" or "GMT+01:00"
        const m = offsetStr.match(/GMT([+-])(\d{2}):(\d{2})/);
        if (!m) return 0;
        const sign = m[1] === '+' ? 1 : -1;
        const hours = parseInt(m[2], 10);
        const minutes = parseInt(m[3], 10);
        return sign * (hours * 60 + minutes);
      };
      const offsetA = parseOffset(a.offset);
      const offsetB = parseOffset(b.offset);
      if (offsetA === offsetB) {
        return a.label.localeCompare(b.label);
      }
      return offsetA - offsetB;
    });
}